/* jshint esversion: 6 */

const Browser = {
  isIframe: function() {
    return window.location !== window.parent.location;
  },

  isMobile: function() {
    if (window.navigator && window.navigator.userAgent) {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    return false;
  },
};
export default Browser;
